import {
  CompWithFormProp,
  FormConfigProps,
} from '../../../constants/constants';
import { DynamicFormField } from '../../DynamicFormField';

export const subjectHistoryConfig: Record<string, FormConfigProps> = {
  usedVisualAid: {
    label:
      'istoriniams įvykiams ir laikotarpiams iliustruoti naudojamos vaizdinės priemonės',
    value: 'usedVisualAid',
  },
  usedRPG: {
    label: 'taikomi vaidmenų žaidimų ir istorinių įvykių modeliavimo metodai',
    value: 'usedRPG',
  },
  usedVideoContentReferences: {
    label:
      'pateikiamos nuorodos į mokomuosius vaizdo įrašus, dokumentinius filmus ir kt.',
    value: 'usedVideoContentReferences',
  },
  predeterminedGraphicOrganizers: {
    label: 'informacija sisteminama pildant numatytas grafines tvarkykles',
    value: 'predeterminedGraphicOrganizers',
  },
};

export const SubjectHistory = ({ form }: CompWithFormProp) => {
  return (
    <DynamicFormField
      formItemConfig={subjectHistoryConfig}
      formPathParams={['subject', 'block3', 'methods']}
      form={form}
    />
  );
};
